module.exports = __webpack_public_path__ + "img/Joanny.9b93d6e4.jpg";